import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48491aba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mt-5 mb-5" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row border-phone p-2 hoverable call-to-us" }
const _hoisted_5 = { class: "col-9 text" }
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "small" }
const _hoisted_9 = { class: "col-3 icon d-flex align-items-center justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mail_icon = _resolveComponent("mail-icon")!
  const _component_improvement_form_modal = _resolveComponent("improvement-form-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "text-decoration-none text-black",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs['form'].open()))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString($props.boldText), 1),
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString($props.smallText), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_mail_icon, { fill: "gradient" })
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_improvement_form_modal, {
      ref: "form",
      "form-type": $props.type,
      "object-id": $props.objectId
    }, null, 8, ["form-type", "object-id"])
  ]))
}